import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../model/enums/status';

@Pipe({
    name: 'variantVersionActive',
    standalone: false
})
export class FilterVariantVersionActive implements PipeTransform {
    transform(versions) {
        return versions.filter((version) => version.status === Status.ACTIVE);
    }
}
